import React from "react";
import { usePermission } from "../../../context/permissionsContext";
import {
  NotAuthorized,
  SubscriptionExpired,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useUser } from "../../../context/userContext";

const PermissionWrapper = ({
  children,
  isPermitted,
  moduleId,
  actionId,
  featureId,
  unauthorizedComponent,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { checkPermission } = usePermission();
  const { user } = useUser();

  if (isPermitted && !checkPermission(moduleId, actionId, featureId)) {
    return unauthorizedComponent || <NotAuthorized />;
  }
  if (
    parseInt(user?.organization?.latest_subscription?.expired) === 1 &&
    parseInt(user?.organization?.latest_subscription?.is_grace_period_active) !== 1 &&
    !location.pathname.includes("billing")
  ) {
    return <SubscriptionExpired />;
  }

  return <>{children}</>;
};

export default PermissionWrapper;
